import { createSlice } from '@reduxjs/toolkit'

import { INITIAL_STYLE_URL, ALTERNATIVE_STYLE_URL, ALTERNATIVE_STYLE_URL_LIGHT, INITIAL_STYLE_URL_LIGHT } from '../utils/styles'

const initialState = {
  lightInitialStyle: INITIAL_STYLE_URL_LIGHT,
  darkInitialStyle: INITIAL_STYLE_URL,
  lightAlternativeStyle: ALTERNATIVE_STYLE_URL_LIGHT,
  darkAlternativeStyle: ALTERNATIVE_STYLE_URL,
  styleUrl: INITIAL_STYLE_URL_LIGHT,
  darkMode: false,
  alternativeMode: false
}

const mapStyleSlice = createSlice({
  name: 'mapStyle',
  initialState,
  reducers: {
    switchStyle: (state) => {
      const { darkMode, alternativeMode } = state

      if (!darkMode && !alternativeMode) {
        state.styleUrl = state.lightInitialStyle
      } else if (darkMode && !alternativeMode) {
        state.styleUrl = state.darkInitialStyle
      } else if (!darkMode && alternativeMode) {
        state.styleUrl = state.lightAlternativeStyle
      } else if (darkMode && alternativeMode) {
        state.styleUrl = state.darkAlternativeStyle
      }
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode
    },
    toggleAlternativeMode: (state) => {
      state.alternativeMode = !state.alternativeMode
    }
  }
})

export const { switchStyle, toggleDarkMode, toggleAlternativeMode } = mapStyleSlice.actions
export const styleUrlSelector = (state) => state.mapStyle.styleUrl
export const darkModeSelector = (state) => state.mapStyle.darkMode
export const alternativeModeSelector = (state) => state.mapStyle.alternativeMode
export default mapStyleSlice.reducer
